import { connect } from 'react-redux';

import OrderShow from '../../components/order/show';

const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = (dispatch) => ({});

const OrderShowConnector = connect(mapStateToProps, mapDispatchToProps)(OrderShow);

export default OrderShowConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/order/show-connector.js
 **/